import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { TransactionStatusService } from '../../transaction-status/transaction-status.service';
import { TransactionTypesService } from '../../transaction-types/transaction-types.service';
import { CompaniesIntegrationsService } from '../companiesintegrations.service';

@Component({
  selector: 'app-integration-edit-sage',
  templateUrl: './integration-edit-sage.component.html',
  styleUrls: ['./integration-edit-sage.component.scss']
})
export class IntegrationEditSageComponent implements OnInit {
  public integration: any = {};
  @ViewChild("formDetails") public formDetails: NgForm;

  public transactionTypes: any[] = [];
  public transactionStatus: any[] = [];

  constructor(
    private dynamicDialogRef: DynamicDialogRef,
    private companiesIntegrationsService: CompaniesIntegrationsService,
    private transactionTypesService: TransactionTypesService,
    private transactionStatusService: TransactionStatusService,
    private messageService: MessageService
  ) { }

  ngOnInit() {
    this.loadData();
    this.loadTypes();
  }

  loadData() {
    this.companiesIntegrationsService.getByCode("sagedespachos").subscribe(
      data => {
        if (data != null) {
          if (data.configuration == null) data.configuration = {};
          this.integration = data;
        } else {
          this.integration = {
            integration_id: 1,
            configuration: {}
          };
        }
        this.loadStatus();
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  loadTypes() {
    this.transactionTypesService.all({}).subscribe(
      data => {
        this.transactionTypes = data.rows;
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }

  loadStatus() {
    if (this.integration.configuration.invoices_transaction_type_id) {
      this.transactionStatusService.all({ transaction_type_id: this.integration.configuration.invoices_transaction_type_id }).subscribe(
        data => {
          this.transactionStatus = data.rows;
        },
        error => {
          this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
        }
      );
    }
  }

  onTransactionTypeChange() {
    this.loadStatus();
  }

  save(){
    this.companiesIntegrationsService.save(this.integration.id, this.integration).subscribe(
      data => {
        this.dynamicDialogRef.close();
      },
      error => {
        this.messageService.add({ closable: false, severity: "error", detail: error.error.title });
      }
    );
  }
  
  cancel() {
    this.dynamicDialogRef.close();
  }
}
